import $ from 'jquery';

export default class AutoComplete {
  init() {
    const autocomplete = $('.autocomplete');

    autocomplete.each((i, elm) => {
      const self = $(elm);

      let currentSelected = -1;

      self.siblings('.input-group').find('input[hx-trigger^="keyup"]')
        .on('focus', event => {
          const input = $(event.target);
          self.find('.autocomplete__content').show();

          input.one('blur', () => {
            setTimeout(() => {
              currentSelected = -1;
              self.find('.autocomplete__row').removeClass('selected')
              self.find('.autocomplete__content').hide();
            }, 500);
          })
        })
        .on('keyup', event => {
          const totalResults = self.find('.autocomplete__row:not(.js-empty)').length;

          if (totalResults === 0) {
            return;
          }

          if (event.keyCode === 38) { // Key up
            currentSelected -= 1;
          } else if (event.keyCode === 40) { // Key down
            currentSelected += 1;
          } else if (event.keyCode === 27) { // Esc
            const input = $(event.target);
            input.blur();
            return;
          } else {
            return;
          }

          if (currentSelected < 0) {
            currentSelected = totalResults - 1;
          } else if (currentSelected === totalResults) {
            currentSelected = 0;
          }

          self.find('.autocomplete__row').removeClass('selected');
          self.find('.autocomplete__row').eq(currentSelected).addClass('selected');
        });

      // Prevent form submit on autocomplete selected
      self.closest('form').on('submit', event => {
        const selected = self.find('.autocomplete__row.selected');

        if (selected.length) {
          const href = selected.find('a').eq(0).attr('href');

          if (href.length) {
            event.preventDefault();
            window.location = href;
          }
        }
      });
    });
  }
}
